var map = {
	"./boards.js": "f2fb",
	"./cores.js": "d274",
	"./files.js": "4bd8",
	"./libraries.js": "fa5b",
	"./projects.js": "6196",
	"./servers.js": "857e",
	"./settings.js": "542c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0765";